<template>
    <div class="duration-since-login" v-if="durationSinceLogin">
        <slot />
        {{ durationSinceLogin }}
    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref, watch } from "vue";

import { useNgSession } from "@/shared/ng/ng-session";
import useUtils from "@/shared/composables/use-utils";

const { isLoggedIn, logonDate } = useNgSession();
const { loggedInDuration } = useUtils();

const durationSinceLogin = ref();

let interval = null;

onMounted(() => {
    if (isLoggedIn.value) {
        durationSinceLogin.value = loggedInDuration(logonDate.value);
    }
});

watch(
    isLoggedIn,
    (newValue) => {
        if (newValue && !interval) {
            interval = setInterval(() => {
                durationSinceLogin.value = loggedInDuration(logonDate.value);
            }, 1000);
        } else if (!newValue && interval) {
            clearInterval(interval);
        }
    },
    { immediate: true },
);

onUnmounted(() => {
    if (interval) {
        clearInterval(interval);
    }
});
</script>
